import React, { ReactElement } from 'react';

const Services: React.FC = (): ReactElement => {
  return (
    <div className="text-dark w-full flex flex-col justify-center items-center">
      <div className="w-full h-full overflow-hidden flex justify-center items-center">
        <img
          src="static/resources/Servicii-nou.jpg"
          className=" min-w-[1000px] w-full min-h-[200px]"
          alt="Description"
        />
        <div className="px-8 sm:p-0 text-light text-lg md:text-xl lg:text-2xl absolute max-w-xl flex flex-col justify-center items-center">
          <p className="text-2xl md:text-3xl lg:text-4xl">Servicii oferite</p>
        </div>
      </div>
      <div className="flex flex-col w-full items-center text-center mt-16 mb-16 text-sm lg:text-lg">
        <p className="mb-4 ">
          1. Evaluare logopedică pe probleme de pronunție și nivelul dezvoltării
          limbajului.
        </p>
        <p className="mb-4">
          2. Terapia tulburărilor de limbaj, corectare sunete, stimularea
          limbajului.
        </p>
        <p className="mb-4">
          3. Evaluarea tulburărilor orofaciale mio-funcționale
        </p>
        <p className="mb-4">4. Evaluarea deglutiției</p>
        <p className="mb-4">5. Evaluarea musculaturii orofaciale</p>
        <p className="mb-4">6. Evaluarea respirației</p>
        <p className="mb-4">7. Evaluarea frenului lingual</p>
        <p className="mb-4">8. Corectarea posturii limbii</p>
        <p className="mb-4">9. Corectarea deglutiției</p>
        <p className="mb-12">
          10. Corectarea problemelor de pronunție rezultate din tulburări
          mio-funcționale
        </p>

        <p>Pentru mai multe informații, nu ezitați să ne contactați!</p>
      </div>
    </div>
  );
};

export default Services;
